import React, { Component } from 'react';
import { find } from 'lodash';
import { imageBasePath } from '../../constants/staticData';

export default class CoverPhoto extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFavouriteVisible: false,
      topFix: false
    };
  }
  componentWillMount() {
    window.addEventListener('scroll', this.scrollPage.bind(this));

  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollPage.bind(this));
  }
  scrollPage() {
    if (window.pageYOffset > document.getElementsByClassName('vendor-base-header')[0].offsetHeight + 370) {
      this.setState({ topFix: true });
    } else {
      this.setState({ topFix: false });
    }
  }
  render() {

    const { garageProfileDetails } = this.props;
    let coverImg = find(this.props.companyImages, function (image) {
      return image.isCover == true;
    });
    let avgCount = garageProfileDetails.reviews && garageProfileDetails.reviews.overview && garageProfileDetails.reviews.overview.avgRating ? garageProfileDetails.reviews.overview.avgRating : '';
    let style = {

      background: coverImg && coverImg.original ? `url("${coverImg.original}")`:'../../images/placeholder.png',
    }
    return (
      <div className="vendor-cover">
        <div className="cover-photo">
          <img style={style} alt="" />
          <label className="profile-pic-upload desk-view"
            htmlFor={this.props.companyImages && this.props.companyImages.length == 0 ? "garageCoverUpload" : ""}
            onClick={() => {
              if (this.props.companyImages && this.props.companyImages.length) {
                this.props.openModal(false);
              }
            }}>Change cover photo
            </label>
          <label className="profile-pic-upload mobile-view hide"
            htmlFor={this.props.companyImages && this.props.companyImages.length == 0 ? "garageCoverUpload" : ""}
            onClick={() => {
              if (this.props.companyImages && this.props.companyImages.length) {
                this.props.openModal(false);
              }
            }}>
            <i className="mdi mdi-camera" />
          </label>
          {this.props.companyImages && this.props.companyImages.length == 0 && <input id="garageCoverUpload" type="file" className="hide" onChange={(e) => this.props.pickImages(e)} multiple />}
        </div>
        <div className="vendor-profile-pic upload-pic">
          <img src={this.props.garageProfileDetails && this.props.garageProfileDetails.logo} alt="logo" />
          <label htmlFor="garageLogoUpload" className="profile-pic-upload logo-upload">
            <i className="mdi mdi-upload"></i>
            Logo
          </label>
          <input id="garageLogoUpload" type="file" className="hide" onChange={(e) => this.props.uploadCompanyLogo(e)} />
        </div>
        <div className="vendor-cover-header">
          <div className="rating">
            <span className={avgCount > 0 && avgCount < 1 && avgCount != 1 ? "mdi mdi-star-half" : avgCount >= 1 ? "mdi mdi-star" : "mdi mdi-star-outline"} />
            <span className={avgCount > 1 && avgCount < 2 && avgCount != 2 ? "mdi mdi-star-half" : avgCount >= 2 ? "mdi mdi-star" : "mdi mdi-star-outline"} />
            <span className={avgCount > 2 && avgCount < 3 && avgCount != 3 ? "mdi mdi-star-half" : avgCount >= 3 ? "mdi mdi-star" : "mdi mdi-star-outline"} />
            <span className={avgCount > 3 && avgCount < 4 && avgCount != 4 ? "mdi mdi-star-half" : avgCount >= 4 ? "mdi mdi-star" : "mdi mdi-star-outline"} />
            <span className={avgCount > 4 && avgCount < 5 && avgCount != 5 ? "mdi mdi-star-half" : avgCount >= 5 ? "mdi mdi-star" : "mdi mdi-star-outline"} />
          </div>
          <h1>{this.props.garageProfileDetails && this.props.garageProfileDetails.companyprofilename}</h1>
          <span className="vendor-specs-list">{this.props.garageProfileDetails && this.props.garageProfileDetails.displaytext}</span>
          <div className="vendor-share-profile">
            <i className="mdi mdi-share-variant" />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/VendorProfile/CoverPhoto.jsx